import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

import { EmpresaCandidata } from 'src/app/core/models/auth.model';

/**
 * Tela de seleção de empresa do fluxo de desambiguação (F7-00 Fase 4).
 *
 * Reutilizada em 3 pontos que podem receber `409 EMPRESA_AMBIGUA`: login
 * (com token de uso único), primeiro acesso e esqueci-senha (sem token —
 * a escolha só é confirmada na chamada final de cada fluxo). O componente é
 * puramente apresentacional: não conhece token, não chama API, não decide
 * navegação — só lista `empresas[].nome` e emite `ref` na escolha.
 *
 * Regra dura (spec §4.3): nunca exibir contagem de candidatos em texto
 * próprio (nada de "você tem contas em N empresas") — a lista em si já é a
 * única informação exposta, tal como o backend a entrega.
 */
@Component({
  standalone: true,
  selector: 'app-empresa-selecao',
  templateUrl: './empresa-selecao.component.html',
  styleUrls: ['./empresa-selecao.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonModule],
})
export class EmpresaSelecaoComponent {
  @Input() empresas: readonly EmpresaCandidata[] = [];
  @Input() loading = false;
  @Input() errorMessage = '';
  @Input() trocarLabel = 'Voltar';

  @Output() escolher = new EventEmitter<string>();
  @Output() trocar = new EventEmitter<void>();

  onEscolher(ref: string): void {
    if (this.loading) return;
    this.escolher.emit(ref);
  }

  onTrocar(): void {
    if (this.loading) return;
    this.trocar.emit();
  }
}
